import mixpanel from 'mixpanel-browser'

// Initialize Mixpanel - only in production
const MIXPANEL_TOKEN = 'f6ea2975809413f15b525a95e5cb7617'
let isMixpanelEnabled = false

export const initMixpanel = () => {
  const isProduction = process.env.NODE_ENV === 'production' && !window.location.hostname.includes('localhost')

  if (isProduction) {
    mixpanel.init(MIXPANEL_TOKEN, {
      autocapture: true,
      record_sessions_percent: 100,
      api_host: 'https://api-eu.mixpanel.com',
    })
    isMixpanelEnabled = true
    console.log('Mixpanel initialized for production environment')
  } else {
    isMixpanelEnabled = false
    console.log('Mixpanel disabled for local development')
  }
}

export const identifyUser = (userId: string, properties: { name: string; email: string }) => {
  if (isMixpanelEnabled) {
    mixpanel.identify(userId)
    mixpanel.people.set('$name', properties.name)
    mixpanel.people.set('$email', properties.email)
  }
}

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (isMixpanelEnabled) {
    mixpanel.track(eventName, properties)
  }
}

export const resetUser = () => {
  if (isMixpanelEnabled) {
    mixpanel.reset()
  }
}

export { mixpanel }
